export default "__VITE_PUBLIC_ASSET__ff881ad6__"